import React from "react";
import { evidenceOf, hexToRgba } from "@/lib/theme";

// Evidence badge — mono, uppercase, dark-safe. Clearly separates fact from speculation.
export function EvidenceBadge({ level, size = "sm", showLabel = true, label }) {
  const ev = evidenceOf(level);
  const text = label || ev.label;
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : size === "lg" ? "px-3 py-1 text-xs" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      data-testid="evidence-badge"
      className={`inline-flex items-center gap-1.5 rounded-full font-mono uppercase tracking-[0.1em] ${pad}`}
      style={{
        backgroundColor: hexToRgba(ev.hex, 0.14),
        color: ev.hex,
        border: `1px solid ${hexToRgba(ev.hex, 0.35)}`,
      }}
      title={text}
    >
      <span style={{ width: 6, height: 6, borderRadius: 999, backgroundColor: ev.hex, display: "inline-block", boxShadow: `0 0 6px ${hexToRgba(ev.hex, 0.7)}` }} />
      {showLabel && <span className="whitespace-nowrap">{text}</span>}
    </span>
  );
}
